import React, { useEffect, useRef, useState } from 'react';
import './Notifications.css';

const TOAST_DURATION = 10000;

const NotificationToast = ({ toast, onDismiss, onClick }) => {
  const [dismissing, setDismissing] = useState(false);
  const [progress, setProgress] = useState(100);
  const startTimeRef = useRef(Date.now());
  const rafRef = useRef(null);

  useEffect(() => {
    startTimeRef.current = Date.now();

    const tick = () => {
      const elapsed = Date.now() - startTimeRef.current;
      const remaining = Math.max(0, 100 - (elapsed / TOAST_DURATION) * 100);
      setProgress(remaining);
      if (remaining > 0) {
        rafRef.current = requestAnimationFrame(tick);
      }
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDismissing(true);
      setTimeout(onDismiss, 200);
    }, TOAST_DURATION);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  const handleDismiss = (e) => {
    e.stopPropagation();
    setDismissing(true);
    setTimeout(onDismiss, 200);
  };

  const handleClick = () => {
    if (onClick) {
      onClick(toast);
      setDismissing(true);
      setTimeout(onDismiss, 200);
    }
  };

  return (
    <div
      className={`notification-toast ${onClick ? 'notification-toast--clickable' : ''} ${dismissing ? 'notification-toast--out' : ''} ${toast.type === 'api-error' ? 'notification-toast--api-error' : ''} ${toast.type === 'api-success' ? 'notification-toast--api-success' : ''}`}
      role="alert"
      aria-live="polite"
      onClick={handleClick}
    >
      <div className="notification-toast__icon" aria-hidden="true">
        {toast.photoUrl ? (
          <img src={toast.photoUrl} alt="" className="notification-toast__photo" />
        ) : (
          toast.icon || '🔔'
        )}
      </div>
      <div className="notification-toast__body">
        <div className="notification-toast__title">{toast.title}</div>
        {toast.body && (
          <div className="notification-toast__text">{toast.body}</div>
        )}
        {toast.org && (
          <span className="notification-org-badge">{toast.org}</span>
        )}
      </div>
      <button
        className="notification-toast__close"
        onClick={handleDismiss}
        aria-label="Dismiss notification"
      >
        ✕
      </button>
      <div className="notification-toast__progress">
        <div
          className="notification-toast__progress-bar"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default NotificationToast;
